/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForOpenAI extends models.ServiceAccountNativeDetailsBaseForSaasAiServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForOpenAI");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForOpenAI.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForOpenAI>): ServiceAccountNativeDetailsForOpenAI {
        let obj = Object.assign(new ServiceAccountNativeDetailsForOpenAI(), model);
        ServiceAccountNativeDetailsForOpenAI.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForOpenAI>): ServiceAccountNativeDetailsForOpenAI {
        if (!model) return null;
        return ServiceAccountNativeDetailsForOpenAI.newInstance(<ServiceAccountNativeDetailsForOpenAI> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForOpenAI) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForOpenAI.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForOpenAI): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasAiServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForOpenAI.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
